<template>
  <div class="pageTip">
    <div class="pageTip-main">
      <img class="mt-72" src="@/assets/img/default/error_default.png" alt="" />
      <p class="font32 fontdark mt-32">无权访问</p>
      <p class="mt-32">
        <Button shape="circle" class="w130px" @click="link">返回</Button>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  data() {
    return {
      time: 6,
      timer: null,
      //0:未认证 1：已认证 2：开发者
      userRole: localStorage.USER_ROLE,
      tipForm: {
        0: "请认证后操作",
        2: "无权访问",
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created() {},
  methods: {
    link() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.pageTip {
  width: 100%;
  height: 100vh;
  background: #f7f8fa;
  padding: 96px;
  &-main {
    width: 100%;
    height: 410px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>
